import { Box, Grid, Stack, Typography } from "@mui/material";
import { formatCount } from "../../utils/utils";
import PosterTile from "../../components/PosterTile";
import MovieRoundedIcon from "@mui/icons-material/MovieRounded";
import { useDetailNavigation } from "../../hooks/useDetailNavigation";
import AddorEmptyTile from "../../components/AddOrEmptyTile";

export default function FiveStarMovies({ data, isOwnProfile, subject }) {
  const isEmpty = data.five_star_movies.length === 0;
  const { openContent } = useDetailNavigation();
  return (
    <>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          alignItems: "stretch",
          gap: { xs: 1, sm: 2 },
          width: "100%",
          my: 2,
        }}
      >
        <Box
          sx={{
            flex: "1 1 auto",
            display: "flex",
            gap: 1,
            overflowX: "auto",
            mr: { xs: -2, sm: -3, md: -4, lg: 0 },
            pr: { xs: 2, sm: 3, md: 4, lg: 0 },
            // Disable scroll bar:
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Box
            sx={{
              height: "100%",
              flex: "0 0 auto",
              display: "flex",
              flexDirection: "column",
              maxWidth: { xs: 120, sm: 130, md: 140 },
            }}
          >
            <Stack direction="row" spacing={0.5} alignItems="flex-start">
              <MovieRoundedIcon color="primary" />
              <Typography
                variant="h5"
                sx={{ fontWeight: "bold", lineHeight: 1 }}
              >
                {isOwnProfile
                  ? "Your favourite movies..."
                  : "Favourite movies..."}
              </Typography>
            </Stack>
            <Typography
              variant="caption"
              sx={{
                lineHeight: 1.2,
                mt: 1,
                textWrap: "balance",
                ml: 3.5,
                // wordBreak: "break-word",
                overflowWrap: "anywhere",
                hyphens: "auto",
              }}
            >
              {subject} rated{" "}
              {isEmpty ? "0" : formatCount(data.five_star_movies.length)} movies
              5 stars
            </Typography>
          </Box>
          {data.five_star_movies.map((movie) => (
            <Box
              key={movie.id}
              sx={{
                flex: "0 0 auto",
                width: { xs: 100, sm: 108 },
              }}
            >
              <PosterTile
                contentId={movie.id}
                contentType={"movie"}
                contentTitle={movie.title}
                imageUrl={movie.image_url}
                onClick={() =>
                  openContent({
                    contentId: movie.id,
                    contentType: "movie",
                    title: movie.title,
                  })
                }
                showStatus={!isOwnProfile ? "full" : null}
              />
            </Box>
          ))}

          {isEmpty &&
            Array.from({ length: 8 }).map((_, index) => (
              <Box
                key={index}
                sx={{
                  flex: "0 0 auto",
                  width: { xs: 80, sm: 108 },
                }}
              >
                <AddorEmptyTile readOnly />
              </Box>
            ))}
        </Box>
      </Grid>
    </>
  );
}
